import { Component, ViewChild, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs/internal/Observable';
import { AppState, selectProfile } from '@app/core/ngrx';
import { OrderUploadComponent } from './components';
import { BulkOrderService } from '@app/core/services/bulk-order.service';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AlertDialogComponent } from '@app/shared/components';

@Component({
  selector: 'ecp-bulk-upload-orders',
  templateUrl: './bulk-upload-orders.component.html',
  styleUrls: ['./bulk-upload-orders.component.scss'],
})
export class BulkUploadOrdersComponent implements OnInit {
  public user$: Observable<any>;
  @ViewChild(OrderUploadComponent) orderUpload: OrderUploadComponent;

  isPreview: boolean = false;
  isUploaded: boolean = false;
  orderDetails: any;
  orderPreview: any;
  userName: any;

  constructor(
    private store: Store<AppState>,
    private bulkOrder: BulkOrderService,
    public datePipe: DatePipe,
    public dialog: MatDialog,
    private router: Router,
  ) {
    this.user$ = this.store.pipe(select(selectProfile));
    this.user$.subscribe((user: any) => {
      this.userName = `${user.firstName} ${user.lastName}`;
      window.localStorage.setItem('token', user.token);
    });
  }

  ngOnInit(): void {}
  previewOrders(orderUploadData: any) {
    if (orderUploadData) {
      this.isPreview = true;
      this.orderDetails = this.mapResponseData(orderUploadData);

      // Order Details
    }
  }
  mapResponseData(orderDetails: any) {
    //map object for RxOrderId
    let mapOrderData = orderDetails.data.map((orderData: any) => {
      var isCompleteJob = orderData.useType ? orderData.useType.toUpperCase() === 'COMPLETE JOB' : false;
      var isFrameOnlyPatient = orderData.useType ? orderData.useType.toUpperCase() === 'FRAME ONLY PATIENT' : false;
      if (isCompleteJob === true) {
        let orderType = orderData?.orderType != null ? orderData?.orderType : '';
        let isValidRx = this.checkRxPattern(orderType.replace(/ /g, ''), orderData?.rxOrderId);
        if (!isValidRx) {
          orderData.uploadStatus = 'failed';
          orderData.uploadMessage += 'Invalid Rx Order ID Format.';
        }
      }
/*       if (isCompleteJob === true || isFrameOnlyPatient === true) {
        let isValidName = this.checkNamePattern(orderData?.patientFirstName, orderData?.patientLastName);
        if (!isValidName.isValid) {
          orderData.uploadStatus = 'failed';
          orderData.uploadMessage += isValidName.errorMsg + ', ' + orderData.uploadMessage;
        }
      } */
      return orderData;
    });
    orderDetails.data = mapOrderData;
    //additional mapping for invalid RXOrderId
    var rxOrderHasError = mapOrderData.filter(order => order.uploadStatus.toLowerCase() === 'failed');
    orderDetails.uploadHasError = rxOrderHasError.length >= 1 ? true : false;
    return orderDetails;
  }
/*   checkNamePattern(firstName: string, lastName: string) {
    if (!firstName && !lastName) {
      return {
        isValid: false,
        errorMsg: 'Invalid Patient Name',
      };
    } else {
      const namePattern = new RegExp(/^[A-Za-z0-9 ]+$/);
      let fNameValid = namePattern.test(firstName);
      let lNameValid = namePattern.test(lastName);

      if (fNameValid && lNameValid) {
        return {
          isValid: true,
          errorMsg: '',
        };
      } else {
        return {
          isValid: false,
          errorMsg: 'Invalid Patient Name',
        };
      }
    }
  } */
  downloadOrders() {
    const reportDate = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    const mappedReport = this.orderDetails.data.map((re: any) => {
      return {
        useType: re.useType,
        locationId: re.locationId,
        fdAccountNumber: re.fdAccountNumber,
        upc: `'${re.upc}`,
        orderType: re.orderType,
        patientFirstName: re.patientFirstName,
        patientLastName: re.patientLastName,
        rxOrderId: re.rxOrderId,
        poNumber: re.poNumber,
        quantity: re.quantity,
        uploadStatus: re.uploadStatus,
        uploadMessage: re.uploadMessage,
      };
    });
    const reportSheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(mappedReport);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, reportSheet, 'Order Report');
    XLSX.writeFile(wb, 'Upload Order Validate ' + reportDate + '.xlsx');
  }
  cancelUpload() {
    this.isPreview = false;
    this.orderDetails = null;
    this.orderUpload.cancelUpload();
  }
  uploadOrders() {
    const pl = {
      fileName: this.orderDetails.fileName,
      UploadedBy: this.userName,
      OrderLineItems: this.orderDetails.data,
    };
    this.bulkOrder.uploadOrders(pl).subscribe(
      res => {
        if (res) {
          this.orderDetails.uploadHasError = false;
          this.orderDetails.uploadReceived = true;
          this.isUploaded = true;
          this.dialog.open(AlertDialogComponent, {
            width: '364px',
            maxWidth: '90vw',
            data: {
              title: 'Bulk Order',
              content: `${pl.OrderLineItems.length} order(s) have been successfully submitted`,
              confirmBtnText: 'Confirm',
            },
            disableClose: true,
          });
          this.router.navigateByUrl('bulk-orders');
        }
      },
      err => {
        console.log(err);
      },
    );
  }
  checkRxPattern(orderType: string, rxOrderId: any) {
    let result = false;
    switch (orderType.toLowerCase()) {
      case 'eyemed':
      case 'privatepay':
      case 'versant': {
        const rxVM = new RegExp(
          /^(?!0{6})(SP[A-Za-z0-9]{5}[A-Za-z1-9]|SP[A-Za-z0-9]{4}[A-Za-z1-9][A-Za-z0-9]|SP[A-Za-z0-9]{3}[A-Za-z1-9][A-Za-z0-9]{2}|SP[A-Za-z0-9]{2}[A-Za-z1-9][A-Za-z0-9]{3}|SP[A-Za-z0-9]{1}[A-Za-z1-9][A-Za-z0-9]{4}|SP[A-Za-z1-9][A-Za-z0-9]{5}|Z[0-9]{8})$/,
          'i',
        );
        result = rxVM.test(rxOrderId);
        break;
      }
      case 'vsp': {
        const rxVsp = new RegExp(
          /^(?!0{6})([0-9]{7}[1-9]|[0-9]{6}[1-9][0-9]|[0-9]{5}[1-9][0-9]{2}|[0-9]{4}[1-9][0-9]{3}|[0-9]{3}[1-9][0-9]{4}|[0-9]{2}[1-9][0-9]{5}|[0-9][1-9][0-9]{6}|[1-9][0-9]{7})$/,
          'i',
        );
        result = rxVsp.test(rxOrderId);
        break;
      }
      case 'uhcvision–spectera': {
        const rxUhc = new RegExp(/^(V[0-9a-zA-Z]{13})$/, 'i');
        result = rxUhc.test(rxOrderId);
        break;
      }
      case 'vba': {
        const rxVba = new RegExp(/^[0-9]{10}$/);
        result = rxVba.test(rxOrderId);
        break;
      }
    }
    return result;
  }
}
